import { Link } from "react-router-dom";
import { ArrowUpRight, Megaphone } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export const ArticleCard = ({ a }) => (
  <Link to={`/communiques/${a.id}`} data-testid={`article-card-${a.id}`} className="group flex flex-col rounded-2xl border border-emerald-900/10 bg-white overflow-hidden hover:shadow-xl hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300">
    <div className="aspect-[16/9] bg-emerald-50 overflow-hidden grid place-items-center">
      {a.image ? <img src={fileUrl(a.image)} alt={a.titre} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <Megaphone className="h-10 w-10 text-emerald-700/40" />}
    </div>
    <div className="p-5 flex-1 flex flex-col gap-2">
      <div className="text-xs uppercase tracking-[0.14em] text-emerald-700 font-semibold">{fmtDate(a.created_at)}</div>
      <h3 className="font-display text-lg font-bold text-slate-900 leading-snug line-clamp-2">{a.titre}</h3>
      <p className="text-sm text-slate-600 line-clamp-3">{a.contenu}</p>
      <span className="mt-auto pt-2 inline-flex items-center gap-1 text-sm font-semibold text-emerald-800">Lire <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" /></span>
    </div>
  </Link>
);
